import styles from './index.module.css'
import React from 'react'
import NoResultsForCampaignSearchSvg from 'assets/images/no-results-for-campaign-search.svg'
import Heading from 'components/ui/heading'
import Stack from 'components/ui/stack'
import Text from 'components/ui/text'

const CampaignNoResultsSearch = (): React.ReactNode => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <NoResultsForCampaignSearchSvg />
      </div>
      <div className={styles.container}>
        <Stack space="xsmall">
          <div>
            <Heading size="600" textAlign="center">
              No results for this search
            </Heading>
          </div>
          <div>
            <Text type="paragraph" textAlign="center">
              Try being less specific or using a different keyword.
            </Text>
          </div>
        </Stack>
      </div>
    </div>
  )
}

export default CampaignNoResultsSearch
